import validators from '../utils/validators';

class User {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      username: (v) => validators.isNotEmptyString(v),
      token: (v) => validators.isNotEmptyString(v),
      lastname: (v) => validators.isNotEmptyString(v),
      firstname: (v) => validators.isNotEmptyString(v),
      gender: (v) => validators.isStringOrNull(v),
      image: (v) => validators.isStringOrNull(v),
      earlyAccess: (v) => validators.isBoolean(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid User property '${property}' in ${data.id}`);
      }

      this[property] = data[property];
    }

    this.roles = [];

    if (Array.isArray(data.roles)) {
      for (const role of data.roles) {
        this.roles.push(role);
      }
    }
  }
}

export default User;
